import { render, staticRenderFns } from "./CaLabelDato.vue?vue&type=template&id=3ebc2b12"
import script from "./CaLabelDato.vue?vue&type=script&lang=js"
export * from "./CaLabelDato.vue?vue&type=script&lang=js"
import style0 from "./CaLabelDato.vue?vue&type=style&index=0&id=3ebc2b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
